import { render, staticRenderFns } from "./AccountPaymentMethods.vue?vue&type=template&id=ca5f4b8a&"
import script from "./AccountPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./AccountPaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports